import { createElement as rc } from 'react';
import PropTypes from 'prop-types';
import { View, styled, fromTheme, nativeOnlyStyles, webOnlyStyles } from 'lib_ui-primitives';

let SpaceApart = styled(View)`
    flex-direction: row;
    justify-content: space-between;
    background-color: ${({darkenBackground}) => darkenBackground ?
        fromTheme('layout', 'backgroundColorDarker') :
        undefined };
`;
SpaceApart = webOnlyStyles(SpaceApart)`
    display: flex;
    flex-grow: 1;
    width: 100%;
`;
// On native, flex-grow: 1 on a child inside a non-height-constrained parent results
// in zero height. Use align-self: stretch to fill the cross-axis instead.
SpaceApart = nativeOnlyStyles(SpaceApart)`
    flex-shrink: 0;
    align-items: center;
    align-self: stretch;
`;

function SpaceApartLayout(props) {
    const { id, title: name, hNode, children, ...otherProps } = props;
    const darkenBackground = /true/i.test(hNode?.darkenBackground);
    return rc(SpaceApart, { name, id, darkenBackground, ...otherProps }, children);
}

SpaceApartLayout.propTypes = {
    children: PropTypes.array,
    hNode: PropTypes.object.isRequired
};

export default SpaceApartLayout;
